module.exports = __webpack_public_path__ + "img/octopus-offshore-structure-hero.f34664b2.jpg";